module.exports = __webpack_public_path__ + "static/media/iconProfessors.7109a5b2.svg";